import { useEffect, useState, useRef, memo } from "react";
import axios from "axios";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { toast } from "react-hot-toast";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import backarrow from "../assets/icon/arrow-right.svg";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

const API_BASE = process.env.REACT_APP_API_URL;

const AnimatedBackground = memo(() => {
  const icons = [
    FaBook,
    FaBookOpen,
    FaRegListAlt,
    FaDatabase,
    FaUserGraduate,
    FaChalkboardTeacher,
    FaCalculator,
    FaChartLine,
    FaCoins,
    FaPenFancy,
    FaRegFileAlt,
    FaPencilAlt,
  ];

  const rows = 5;
  const cols = 11;
  const iconArray = [];

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      iconArray.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 15 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  }

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {iconArray.map((item, i) => (
        <motion.div
          key={i}
          className="absolute text-white/50"
          style={{
            top: `${item.top}%`,
            left: `${item.left}%`,
            opacity: item.opacity,
          }}
          initial={{ scale: 0.5 }}
          animate={{
            x: [0, item.xOffset, 0],
            y: [0, item.yOffset, 0],
            scale: [0.5, 1, 0.5],
          }}
          transition={{
            duration: item.duration,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <item.Icon size={item.size} />
        </motion.div>
      ))}
    </div>
  );
});

const StudentCourses = () => {
  const [getallcourses, setGetallcourses] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [visiblePagesCount, setVisiblePagesCount] = useState(
    window.innerWidth < 768 ? 2 : 3
  );

  const debounceTimeoutcourse = useRef(null);
  const CourseNamefilterref = useRef("");
  const navigate = useNavigate();
  const location = useLocation();
  const studentid = location.state?.studentid;

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
      setVisiblePagesCount(window.innerWidth < 768 ? 2 : 3);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    return () => {
      if (debounceTimeoutcourse.current)
        clearTimeout(debounceTimeoutcourse.current);
    };
  }, []);

  const fetchCourses = async (pageNumber = page) => {
    if (!studentid) return;
    setLoading(true);

    const searchParam = CourseNamefilterref.current.trim();
    const limit = windowHeight < 1000 ? 6 : 9;

    try {
      const res = await axios.get(
        `${API_BASE}/api/student/Get-Courses-By-Student/${studentid}?search=${searchParam}`,
        {
          params: { page: pageNumber, limit },
          headers: { Authorization: localStorage.getItem("token") },
        }
      );

      if (res.status === 200) {
        const courses = res.data.data.courses;

        const coursesWithPayments = await Promise.all(
          courses.map(async (course) => {
            try {
              const payRes = await axios.get(
                `${API_BASE}/api/student/Student-Payment-Get/${studentid}/${course._id}`,
                { headers: { Authorization: localStorage.getItem("token") } }
              );

              const payment = payRes.data?.data || null;

              let displayPaymentStatus = "PartiallyPaid";
              if (payment) {
                if (payment.Totalamount === 0) {
                  displayPaymentStatus = "Free";
                } else if (payment.Amountpaid >= payment.Totalamount) {
                  displayPaymentStatus = "FullyPaid";
                } else {
                  displayPaymentStatus = "PartiallyPaid";
                }
              }

              return {
                ...course,
                paymentStatus: displayPaymentStatus,
                payment,
              };
            } catch (err) {
              console.error(
                "Error fetching payment for course:",
                course._id,
                err
              );
              return {
                ...course,
                paymentStatus: "PartiallyPaid",
                payment: null,
              };
            }
          })
        );

        setGetallcourses(coursesWithPayments);
        setTotalPages(res.data.data.totalPages);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "خطا در دریافت دوره‌ها. لطفاً دوباره تلاش کنید.";
      toast.error(errorMessage);
      console.error("Error fetching student courses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses(page);
  }, [page, windowHeight, studentid]);

  const handleCourseInputChange = (value) => {
    CourseNamefilterref.current = value;
    setPage(1);
    if (debounceTimeoutcourse.current)
      clearTimeout(debounceTimeoutcourse.current);
    debounceTimeoutcourse.current = setTimeout(() => fetchCourses(1), 500);
  };

  const handleshowpaymentcom = (id) => {
    navigate("/Mainpage/StudentPayments", {
      state: { courseid: id, studentid },
    });
  };

  const halfVisible = Math.floor(visiblePagesCount / 2);
  let startPage = Math.max(1, page - halfVisible);
  let endPage = Math.min(totalPages, startPage + visiblePagesCount - 1);
  if (endPage - startPage + 1 < visiblePagesCount) {
    startPage = Math.max(1, endPage - visiblePagesCount + 1);
  }

  useEffect(() => {
    if (!studentid) navigate("/Mainpage/StudentsInf");
  }, [studentid, navigate]);

  if (localStorage.getItem("token") === null) return <Navigate to="/" />;

  const handleback = () => {
    navigate("/Mainpage/StudentsInf");
  };

  return (
    <div className="relative min-h-screen w-full bg-gray-800 flex flex-col items-center p-4">
      <AnimatedBackground />

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl w-full max-w-4xl mx-auto border border-white/30 overflow-hidden mt-8"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <img
            src={backarrow}
            alt="back"
            className="w-8 h-8 cursor-pointer hover:scale-110 transition"
            onClick={handleback}
          />
          <h2 className="text-2xl font-bold text-gray-800">دوره‌های دانشجو</h2>
          <div className="w-8" />
        </div>

        {/* Search */}
        <div className="p-6 pt-4">
          <div className="relative w-full max-w-[300px] mx-auto">
            <input
              type="text"
              placeholder="فیلتر : نام دوره ..."
              onChange={(e) => handleCourseInputChange(e.target.value)}
              className="w-full pl-12 pr-4 py-3 rounded-md border-2 border-gray-300 focus:border-gray-700 outline-none"
            />
            <IoSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 text-xl" />
          </div>
        </div>

        {/* Grid Cards */}
        <div className="px-6 pb-10">
          {loading ? (
            <p className="text-center py-12 text-xl font-bold text-gray-600">
              در حال دریافت اطلاعات...
            </p>
          ) : getallcourses.length === 0 ? (
            <p className="text-center py-12 text-xl font-bold text-gray-600">
              دوره‌ای برای این دانشجو یافت نشد!
            </p>
          ) : (
            <>
              <div className="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {getallcourses.map((item, i) => (
                  <motion.div
                    key={item._id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: i * 0.05 }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handleshowpaymentcom(item._id)}
                    className="bg-white rounded-xl shadow-md overflow-hidden cursor-pointer border border-gray-200"
                  >
                    <div className="p-4 flex flex-col items-center">
                      {/* عکس دوره */}
                      <div className="w-20 h-20 rounded-full border-2 border-[#265166] overflow-hidden mb-3">
                        {item.CoursesImage?.fileName ? (
                          <img
                            src={`${API_BASE}/${item.CoursesImage.fileName}`}
                            alt={item.CourseName}
                            className="w-full h-full object-cover"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "";
                              e.target.parentNode.querySelector(
                                "div"
                              ).style.display = "flex";
                            }}
                          />
                        ) : null}
                        <div
                          className={`w-full h-full bg-gray-200 flex items-center justify-center text-gray-500 text-xs font-bold ${
                            item.CoursesImage?.fileName ? "hidden" : "flex"
                          }`}
                        >
                          عکس موجود نیست
                        </div>
                      </div>

                      {/* نام دوره */}
                      <h3 className="text-lg font-bold text-gray-800 mb-1 text-center">
                        {item.CourseName}
                      </h3>

                      {/* توضیحات */}
                      <p className="text-gray-600 text-center mb-3 text-sm line-clamp-2">
                        {item.CourseDescription || "بدون توضیحات"}
                      </p>

                      <div className="w-full h-px bg-gray-300 my-3" />

                      {/* وضعیت پرداخت */}
                      <p
                        className={`font-bold text-sm ${
                          item.paymentStatus === "FullyPaid"
                            ? "text-green-600"
                            : item.paymentStatus === "PartiallyPaid"
                            ? "text-red-600"
                            : "text-blue-600"
                        }`}
                      >
                        {item.paymentStatus === "FullyPaid"
                          ? "پرداخت کامل"
                          : item.paymentStatus === "PartiallyPaid"
                          ? "پرداخت ناقص"
                          : "رایگان"}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex justify-center items-center gap-3 mt-10">
                  <button
                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                    disabled={page === 1}
                    className="p-2 rounded-full disabled:opacity-50"
                  >
                    <FaArrowRight size={20} />
                  </button>

                  {Array.from(
                    { length: endPage - startPage + 1 },
                    (_, i) => startPage + i
                  ).map((num) => (
                    <motion.button
                      key={num}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={() => setPage(num)}
                      className={`w-8 h-8 rounded-md font-bold ${
                        num === page ? "bg-[#265166] text-white" : "bg-gray-200"
                      }`}
                    >
                      {num}
                    </motion.button>
                  ))}

                  <button
                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}
                    className="p-2 rounded-full disabled:opacity-50"
                  >
                    <FaArrowLeft size={20} />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default StudentCourses;
